import React, { useEffect, useState } from "react";

const MLB = () => {
  const [partidos, setPartidos] = useState([]);
  const [loading, setLoading] = useState(true);

  const fechaHoy = new Date().toISOString().slice(0, 10);
  const rutaJSON = `/${fechaHoy}_partidos_mlb.json`;

  useEffect(() => {
    fetch(rutaJSON)
      .then((res) => {
        if (!res.ok) throw new Error(`Archivo no encontrado: ${rutaJSON}`);
        return res.json();
      })
      .then((data) => {
        setPartidos(Array.isArray(data) ? data : [data]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error al cargar partidos:", err.message);
        setLoading(false);
      });
  }, []);

  const colorConfianza = (nivel) => {
    if (nivel === "Alta") return "green";
    if (nivel === "Media") return "orange";
    return "red";
  };

  return (
    <div style={{ padding: "1.5rem" }}>
      <h1>⚾ <span style={{ color: "#d40000" }}>Partidos de MLB</span> - {fechaHoy.split("-").reverse().join(" / ")}</h1>
      {loading ? (
        <p>Cargando partidos...</p>
      ) : partidos.length === 0 ? (
        <p>🗨️ No hay partidos disponibles hoy.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", marginTop: "1rem" }}>
          {partidos.map((partido, index) => (
            <div key={index} style={{
              border: `2px solid #3399ff`,
              padding: "1rem",
              borderRadius: "12px",
              backgroundColor: "#fcfcfc",
              boxShadow: "0 0 6px rgba(0,0,0,0.1)"
            }}>
              <h3 style={{ marginBottom: "0.5rem" }}>
                <span style={{ background: "#ff9900", padding: "0.2rem 0.5rem", borderRadius: "5px", marginRight: "0.5rem" }}>
                  🟧 VS
                </span>
                {partido.equipo_local} vs {partido.equipo_visitante}
              </h3>
              <p>🕒 <strong>Hora:</strong> {new Date(partido.fecha_hora).toLocaleString()}</p>
              <p>🎯 <strong>Confianza IA:</strong> <span style={{ color: colorConfianza(partido.nivel_confianza), fontWeight: "bold" }}>{partido.nivel_confianza}</span></p>
              <p>🏅 <strong>Apuesta Equipo:</strong> <span style={{ fontWeight: "bold" }}>{partido.apuesta_equipo}</span></p>
              <p>📊 <strong>Apuesta Total:</strong> <span style={{ fontWeight: "bold" }}>{partido.apuesta_total}</span></p>
              <p>🎯 <strong>Apuesta Ponches:</strong> <span style={{ fontWeight: "bold" }}>{partido.apuesta_ponches}</span></p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MLB;
